import { render } from "./Imagebox.vue?vue&type=template&id=054fe5f4&scoped=true"
import script from "./Imagebox.vue?vue&type=script&lang=js"
export * from "./Imagebox.vue?vue&type=script&lang=js"

import "./Imagebox.vue?vue&type=style&index=0&id=054fe5f4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054fe5f4"]])

export default __exports__